<template>
  <div
    id="panel"
    :style="style"
  >
    <messageCentre />
    <div class="custom">
      <b-navbar toggleable="lg">
        <b-navbar-brand>
          <font-awesome-icon icon="chart-bar" /> | Stat-Milestones
        </b-navbar-brand>

        <span
          @click="sendEvent('navigation', 'click', 'dark-mode'); theme.darkMode = !theme.darkMode;"
        >
          <font-awesome-icon :icon="theme.icon" />
        </span>

        <span
          v-b-toggle.sidebar-1
          @click="sendEvent('navigation', 'click', 'expand-navigation')"
        >
          <font-awesome-icon icon="bars" />
        </span>
      </b-navbar>
    </div>

    <b-carousel v-model="slide" moid="carousel-1" no-hover-pause controls :interval="interval" ref="carousel">
      <div v-for="comp in views" :key="comp.index">
        <b-carousel-slide>
          <template #img>
            <keep-alive>
              <component :is="comp" />
            </keep-alive>
          </template>
        </b-carousel-slide>
      </div>
    </b-carousel>

    <div style:="style">
    <b-sidebar id="sidebar-1" ref="sidebar-1">
      <template #title>
        <font-awesome-icon icon="chart-bar" /> | Stat-Milestones
      </template>
      <br>

      <b-nav style:="style" class="text-center" vertical>
        <h4>Navigation</h4>
        <template v-if="custom.enabled">
          <b-nav-item v-b-toggle.sidebar-1 @click="changeView('custom')">
            {{ custom.title }}
          </b-nav-item>
        </template>
        <b-nav-item v-b-toggle.sidebar-1 @click="changeView('followers')">
          Followers
        </b-nav-item>
        <template v-if="goals.enabled">
          <b-nav-item v-b-toggle.sidebar-1 @click="changeView('goals')">
            Twitch Goal
          </b-nav-item>
        </template>
        <template v-if="charity.enabled">
          <b-nav-item v-b-toggle.sidebar-1 @click="changeView('charity')">
            Twitch Charity
          </b-nav-item>
        </template>
        <template v-if="subscribers.enabled">
          <b-nav-item v-b-toggle.sidebar-1 @click="changeView('subscribers')">
            Subscribers
          </b-nav-item>
        </template>
        <b-nav-item v-b-toggle.sidebar-1 @click="changeView('hypetrain')">
          Hype Train
        </b-nav-item>
      <template v-if="messages.enabled">
        <b-nav-item v-b-toggle.sidebar-1 @click="changeView('messages')">
          Messages
        </b-nav-item>
      </template>
      <b-nav-text>
        <font-awesome-icon icon="chart-bar" /> | Stat-Milestones
      </b-nav-text>
      </b-nav>
      <br>

      <b-list-group flush>
        <div :style="style">
          <div
            v-show="this.motd != ''"
            @mouseover="sendEvent('information', 'hover', 'MOTD')"
          >
            <b-list-group-item>
              MOTD: <b> {{ this.motd }} </b>
            </b-list-group-item>
          </div>

          <div v-show="isNotLinked()">
            <b-list-group-item class="mx-auto">
              Recommended:
              <b-button
                @click="
                  shareIdentity();
                  sendEvent('informatsion', 'click', 'share-identity');
                "
              >
                Share Identity
              </b-button>
            </b-list-group-item>
          </div>
        </div>
      </b-list-group>

</b-sidebar>
  </div>
</div>
</template>

<script>
import { SET_RELEASE_STATE } from "@/store/mutations";

import Custom from "@/components/page-panel/Custom";
import Followers from "@/components/page-panel/Followers";
import Goals from "@/components/page-panel/Goals";
import Messages from "@/components/page-panel/Messages";
import Subscribers from "@/components/page-panel/Subscribers";
import HypeTrain from "@/components/page-panel/HypeTrain";
import MessageCentre from "@/components/utils/MessageCentre";
import Charity from "@/components/page-panel/Charity";
import ConfigAPI from "@/api/config.js";
import UserAPI from "@/api/user.js";
import SubscribersAPI from "@/api/subscribers.js";
import GoalsAPI from "@/api/goals.js";
import CharityAPI from "@/api/charity.js";

import store from "@/store/index.js";


export default {
  name: "panel",
  data() {
    return {

      appBkgColour: "white",
      appFontColour: "black",

      theme: {
        darkMode: false,
        icon: "moon",
      },
      motd: "",
      channelName: "",

      slide: 0,
      interval: 0,
      // theme settings
      backgroundColour: "#5583c7",
      fontColour: "#FFFFFF",
      view: "followers",
      identityHover: false,

      messages: {
        enabled: false,
        title: ""
      },

      custom: {
        enabled: false,
        title: ""
      },

      subscribers: {
        enabled: false
      },

      goals: {
        enabled: false
      },

      charity: {
        enabled: false
      },

      defaultView: "",
      controlBkgColour: "#183153",
      views: [],
      viewIndex: 0
    };
  },
  props: {
    locale: String
  },
  mounted () {
    if (this.locale) {
      ga("set", "language", this.locale);
    }

    const { channelId } = store.state;
    const username = ConfigAPI.getUsername();
    this.getSubscribers();
    this.getGoals();
    this.getCharities();
    this.sendEvent("view", "view", username + "-" + channelId);

    this.setMessageOfTheDay();

    if (this.defaultView != "") {
      this.views.push(this.defaultView);
    }
    this.pushNotExist("followers", this.views);

    if (this.subscribers.enabled) {
      this.pushNotExist("subscribers", this.views);
    }

    if (this.custom.enabled) {
      this.pushNotExist("custom", this.views);
    }

    if (this.messages.enabled) {
      this.pushNotExist("messages", this.views);
    }

    this.pushNotExist("hypetrain", this.views);
  },
  created() {
    this.setSettings();
  },
  methods: {
    isNotLinked() {
      const { channelId } = store.state;
      if (!Twitch.ext.viewer.id) {
        return true;
      }
      return false;
    },
    shareIdentity() {
      UserAPI.requestUserID();
    },
    setSettings() {
      const config = ConfigAPI.getBroadcasterConfig();

      if (config.panel_settings) {
        const panel = config.panel_settings;
        if (panel.font_colour) {
          this.fontColour = panel.font_colour;
        }
        if (panel.background_colour) {
          this.backgroundColour = panel.background_colour;
        }
        if (panel.dark_mode) {
          this.theme.darkMode = panel.dark_mode
        }
      }

      if (config.messages) {
        const messages = config.messages;
        if (messages.enabled) {
          this.messages.enabled = true;
        }
      }

      if (config.custom) {
        const custom = config.custom;
        if (custom.enabled) {
          this.custom.enabled = true;
          this.custom.title = custom.title;
        }
      }

      if (config.misc) {
        const misc = config.misc;
        if (misc.view) {
          this.defaultView = misc.view;
        }
      }

      return;
    },
    pushNotExist(item, array) {
      if (array.indexOf(item) === -1) {
        array.push(item);
      }
    },
    setMessageOfTheDay() {
      const config = ConfigAPI.getGlobalConfig();

      if (config.motd) {
        this.motd = config.motd;
      }
      return;
    },
    changeView (viewName) {
      this.sendEvent("navigation", "click", "page-view-" + viewName);
      const index = this.views.indexOf(viewName);
      this.slide = index;
    },
    getSubscribers() {
      SubscribersAPI.getSubscribers()
        .then(resp => {
          if (resp.data.error) {
            return;
          }

          this.subscribers.enabled = true;
          this.pushNotExist("subscribers", this.views);
        })
        .catch(error => {});
    },
    getGoals() {
      GoalsAPI.getGoals()
        .then(resp => {
          if (resp.data.error) {
            return;
          }

          if (resp.data.count > 0) {
            this.goals.enabled = true;
            this.pushNotExist("goals", this.views);
          }
        })
        .catch(error => {});
    },
    getCharities() {
      CharityAPI.getCharities()
        .then(resp => {
          if (resp.data.error) {
            return;
          }
          if (resp.data.count > 0) {
            this.charity.enabled = true;
            this.pushNotExist("charity", this.views);
          }
        })
        .catch(error => {});
    }
    
  },
  computed: {
    style() {
      return {};
    }
  },
  watch: {
    "theme.darkMode": function (enabled) {
      if (enabled) {
        this.appBkgColour = "#183153";
        this.appFontColour = "white";
        this.theme.icon = "sun";
        return
      }
      this.appBkgColour = "white"
      this.appFontColour = "black";
      this.theme.icon = "moon";
    },
  },
  components: {
    custom: Custom,
    followers: Followers,
    messages: Messages,
    subscribers: Subscribers,
    hypetrain: HypeTrain,
    MessageCentre,
    goals: Goals,
    charity: Charity,
  }
};
</script>

<style>
.btn-secondary {
  background-color: v-bind(backgroundColour);
  color: v-bind(fontColour);
}
</style>

<style scoped>

body {
  background-color: v-bind(appBkgColour);
  color: v-bind(appFontColour);
}

div {
  background-color: v-bind(appBkgColour);
  color: v-bind(appFontColour);
}

.list-group .list-group-item {
  background-color: v-bind(appBkgColour);
  color: v-bind(appFontColour);
}

.popover {
  max-width: none;
  width: 100%;
}

.footer-fade-enter-active,
.footer-fade-leave-active {
  transition: opacity 0.3s ease;
}

.footer-fade-enter,
.footer-fade-leave-to {
  opacity: 0;
}

.custom {
  text-align: center;
  background-color: v-bind(backgroundColour);
  color: v-bind(fontColour);
}

.navbar {
  background-color: v-bind(backgroundColour);
  color: v-bind(fontColour);
}

.navbar .navbar-brand {
    background-color: v-bind(backgroundColour);
    color: v-bind(fontColour);
}

.navbar .navbar-text {
  color: v-bind(fontColour);
}

.nav-link {
  color: black;
}

.navbar .navbar-brand {
  color: v-bind(fontColour);
}

.navbar-light .navbar-nav .nav-link {
  color: unset;
}

.navbar-light .navbar-nav .nav-link:hover {
  color: black;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}

.btn-secondary {
  background-color: v-bind(backgroundColour);
  color: v-bind(fontColour);
}
</style>

<style>
.carousel-item {
  height: 640px;
}

a.carousel-control-next {
  background-color: v-bind(controlBkgColour);
  width: 20px;
}

a.carousel-control-prev {
  background-color: v-bind(controlBkgColour);
  width: 20px;
}

.b-sidebar-header {
  background-color: v-bind(backgroundColour);
  color: v-bind(fontColour);
}

.list-group .list-group-item {
  background-color: v-bind(appBkgColour);
  color: v-bind(appFontColour);
}

.card .card-header {
  background-color: v-bind(appBkgColour);
  color: v-bind(appFontColour);
}

.card .card-body {
  background-color: v-bind(appBkgColour);
  color: v-bind(appFontColour);
}

</style>
